import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { withTranslation } from 'react-i18next';

const BlockPreviewCoverFront = inject("stores") (
    observer (
        class BlockPreviewCoverFront extends Component {

            constructor(props) {
                super(props);
                this.props = props;
                this.urlAPI = process.env.REACT_APP_URL_API;
                this.urlPublic = process.env.REACT_APP_URL_PUBLIC;

                this.storeUi = this.props.stores.storeUi;

                this.state = {
                    hasCoverPng: false,
                    hasCoverJpg: false,
                    coverDir: "CoversVKg-all"
                }
            }

            componentDidMount = async() => {
                this.checkCovers();
            }

            componentDidUpdate = async(prevProps) => {
                if (prevProps.sku !== this.props.sku) {
                    this.checkCovers();
                }
            }

            checkCovers = async() => {
                let hasCoverPng = false;
                let hasCoverJpg = false;
                let coverDir;

                const returnPng = await this.storeUi.checkFile(this.props.sku, 'imgLargePng');
                if ('error' in returnPng[0]) {
                    hasCoverPng = false;
                } else {
                    hasCoverPng = true;
                    coverDir = "CoversVKg-all";
                }
                
                if (!hasCoverPng) {
                    const returnJpg = await this.storeUi.checkFile(this.props.sku, 'imgLargeJpg');
                    if ('error' in returnJpg[0]) {
                        hasCoverJpg = false;
                    } else {
                        hasCoverJpg = true;
                        coverDir = "CoversVKg";
                    }
                }

                this.setState({
                    hasCoverPng: hasCoverPng,
                    hasCoverJpg: hasCoverJpg,
                    coverDir: coverDir,
                    image: this.urlPublic + "/public/images/" + coverDir + "/" + this.props.sku + "." + (hasCoverPng ? "png" : "jpg")
                })
            }

            handleClick = () => {
                const ext = this.state.hasCoverPng 
                    ?   "png" 
                    :   "jpg"
                const url = this.urlPublic + "/public/images/" + this.state.coverDir + "/" + this.props.sku + "." + ext;
                window.open(url);
            }

            handleError = () => {
                this.setState({
                    image: this.urlPublic  + "/public/images/img-not-available.png"
                })
            }

            render() {
                return (
                    this.state.hasCoverPng || this.state.hasCoverJpg
                    ?   <div 
                            className="block-content--book__preview-front --link"
                            onClick = {(e) => this.handleClick()}
                        >
                            <img 
                                onError={() => this.handleError()} 
                                src={this.state.image} 
                                alt="cover preview"
                                className={(this.props.soldout ? " --soldout" : "")}
                            />
                            <span className="circle plus"></span>
                        </div>
                    :   null
                )
            }
        }
    )
)

export default withTranslation()(BlockPreviewCoverFront);

